var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5V18.5C9 19.2956 9.31607 20.0587 9.87868 20.6213C10.4413 21.1839 11.2044 21.5 12 21.5C12.7956 21.5 13.5587 21.1839 14.1213 20.6213C14.6839 20.0587 15 19.2956 15 18.5V17.5M10 5.5C10 4.96957 10.2107 4.46086 10.5858 4.08579C10.9609 3.71071 11.4696 3.5 12 3.5C12.5304 3.5 13.0391 3.71071 13.4142 4.08579C13.7893 4.46086 14 4.96957 14 5.5C15.1484 6.04303 16.1274 6.88833 16.8321 7.9453C17.5367 9.00227 17.9404 10.2311 18 11.5V14.5C18.0753 15.1217 18.2954 15.7171 18.6428 16.2381C18.9902 16.7592 19.4551 17.1914 20 17.5H4C4.54494 17.1914 5.00981 16.7592 5.35719 16.2381C5.70457 15.7171 5.92474 15.1217 6 14.5V11.5C6.05956 10.2311 6.4633 9.00227 7.16795 7.9453C7.8726 6.88833 8.85159 6.04303 10 5.5Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8.5,
    r: 4,
    fill: "#FF5630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3bb50a9b918b56276ab7b7e56c7c6535.svg";
export { ForwardRef as ReactComponent };